"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertMailMagazineConsentInput = exports.MAIL_MAGAZINE_CONSENT_LABEL = exports.MAIL_MAGAZINE_CONSENT_INPUT_NAME = void 0;
var input_store_factory_1 = require("@hikakaku/shared/stores/estimate_form/common/input/input_store_factory");
exports.MAIL_MAGAZINE_CONSENT_INPUT_NAME = 'estimate_form[permit_mail_magazine]';
exports.MAIL_MAGAZINE_CONSENT_LABEL = '新着情報や買取相場、キャンペーン情報を受け取る';
var insertMailMagazineConsentInput = function (inputProps, consent) {
    if (!(consent === null || consent === void 0 ? void 0 : consent.visible)) {
        return inputProps;
    }
    var consentProps = {
        type: input_store_factory_1.InputType.MAIL_MAGAZINE_CONSENT,
        name: exports.MAIL_MAGAZINE_CONSENT_INPUT_NAME,
        label: exports.MAIL_MAGAZINE_CONSENT_LABEL,
        checked: consent.checked
    };
    var emailIndex = inputProps.findIndex(function (prop) { return prop.type === input_store_factory_1.InputType.EMAIL; });
    var insertAt = emailIndex === -1 ? inputProps.length : emailIndex + 1;
    return __spreadArray(__spreadArray(__spreadArray([], inputProps.slice(0, insertAt), true), [consentProps], false), inputProps.slice(insertAt), true);
};
exports.insertMailMagazineConsentInput = insertMailMagazineConsentInput;
